import React, { Component, PropTypes } from 'react';
import { parseQueryString } from './../store/history.js';
import { confDepositPayment as conf } from './../payment/common/lib/utils/router-config.js';
import navDeposit from './../payment/navdeposit/index.js';
import bonus from './../payment/bonus/index.js';
import payment from './../payment/payment/index.js';

class DepositShopPayment extends Component {
	componentWillMount() {
		const { history: { push }, location } = this.props;
		const query = parseQueryString(location);
		/* TODO: the navigation is set from components/deposit-payment.js
		 navDeposit.init(conf);
		 */
		payment.shopInit();
		bonus.init({
			selectedShopBonusId: query.bonusId,
			paymentMethods: query.bonusPaymentMethods,
			shopDepositBonusCallback() {
				/* Transition to payment action if the flow is deposit bonus selected from shop*/
				const queryString = query.referrer ? `?referrer=${query.referrer}` : '';
				push(`/account/deposit/payment${queryString}`);
			}
		});
	}

	componentWillUnmount() {
		//
	}

	render() {
		return (
			<div id="deposit-shop-payment" />
		);
	}
}

DepositShopPayment.propTypes = {
	history: PropTypes.object,
	location: PropTypes.object
};

export default DepositShopPayment;



// WEBPACK FOOTER //
// ./mobile-core/src/components/deposit-shop-payment.js